export default "__VITE_ASSET__Fqvu210q__"